var generateStyle = function generateStyle(componentTheme) {
  return {
    userInput: {
      flex: '1 1 auto',
      color: componentTheme.userInputColor,
      padding: componentTheme.userInputPadding
    },
    itemBody: {
      fontSize: componentTheme.itemBodyFontSize,
      fontWeight: componentTheme.itemBodyFontWeight
    }
  };
};
export default generateStyle;